'use strict';
var BuyPathCalendar = function(isCalendarSearch) {
    this.isCalendarSearch = isCalendarSearch;
};

BuyPathCalendar.prototype.build = function() {
    return this.isCalendarSearch ? 'CALENDAR_SEARCH_FLEXIBLE_DATES' : 'FLIGHTS_RESULTS_SEARCH_FORM';
};

module.exports = BuyPathCalendar;
